import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useCookie } from 'hooks';
import { useFeatureFlag, FLAGS } from 'lib/featureFlags';
import { migrateCollections } from 'redux/actions';
import Routes from 'routes';
import Toaster from 'components/Toaster';
import { HelmetProvider } from 'react-helmet-async';
import { IS_PRODUCTION } from '../constants';
import ErrorHandler from './ErrorHandler';
import BpConnect from './BpConnect';
import '@teespring/ts-components/dist/styles/base-styles.scss';
import '@teespring/ts-components/dist/styles/ts-styles.scss';
import 'styles/local-styles.scss';

export const App = () => {
  const { setValue } = useCookie();
  const showCollections = useFeatureFlag(FLAGS.SHOW_COLLECTIONS);

  const dispatch = useDispatch();

  const migrateCollectionData = useCallback(async () => {
    await dispatch(migrateCollections());
  }, [dispatch]);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const iterableCampaignId = query.get('iterableCampaignId');
    const iterableTemplateId = query.get('iterableTemplateId');

    if (iterableCampaignId) setValue('iterableCampaignId', iterableCampaignId);
    if (iterableTemplateId) setValue('iterableTemplateId', iterableTemplateId);
  }, [setValue]);

  useEffect(() => {
    if (showCollections && IS_PRODUCTION) {
      migrateCollectionData();
    }
  }, [showCollections, migrateCollectionData]);

  return (
    <HelmetProvider>
      <Toaster>
        <ErrorHandler>
          <BpConnect />
          <Routes />
        </ErrorHandler>
      </Toaster>
    </HelmetProvider>
  );
};

export default App;
